import axios from "axios";

const requestTabletPrint = parameter => {
  return axios.post(
    `${process.env.VUE_APP_APIURL}/api/app/tablet/print`,
    parameter
  );
};

// function requestTabletList(parameter){
// 	return axios.post(`${process.env.VUE_APP_BASEURL}/api/app/tablet/tablet-page`, parameter.tablet)
// }

// function registTablet(parameter){
// 	return axios.post(`${process.env.VUE_APP_BASEURL}/api/app/tablet/regist/tablet`,parameter.tablet)
// }
// function requestTabletDelete(id){
// 	return axios.post(`${process.env.VUE_APP_BASEURL}/api/app/tablet/delete/tablet?id=${id}`)

// }
export {
  // requestTabletList,
  // 	registTablet,
  // 	requestTabletDelete,
  requestTabletPrint
};
